import React from "react";
import "./index.css";
import { navigate } from "@reach/router";
import { useStore } from "../../context";
import TagManager from 'react-gtm-module'
import logoanai from "../../images/logos/logoanai.png";

export default () => { 
  TagManager.dataLayer({
    dataLayer: {
      event: "pageview",
      path: "/menuMain"
    }
  });
  
  const { dispatch } = useStore();

  const handleClickOpenPension = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "pageview",
        path: "/pension"
      }
    });
    navigate("/pension/list");
  };

  const handleClickOpenInscripcion = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "pageview",
        path: "/inscripcion"
      }
    });
    navigate("/inscripcion/list");
  };
  
  return (
    <div className="login-bg">
      <div className="login-card" style={{ maxWidth: 560 }}>
        <img src={logoanai} alt="ANAI Logo" className="login-logo" />
        <div className="login-title">Portal de Servicios</div>
        <div className="login-subtitle">
          Inscripciones, matrícula y cobros — ANAI
        </div>

        <div className="menu-card-grid">
          <div className="menu-card-item" onClick={handleClickOpenPension}>
            <div className="menu-icon icon-pension">💳</div>
            <div className="menu-label">Pagar Pensión</div>
            <div className="menu-desc">Consulta y pago de pensiones</div>
          </div>

          <div className="menu-card-item" onClick={handleClickOpenInscripcion}>
            <div className="menu-icon icon-admision">📋</div>
            <div className="menu-label">Admisiones</div>
            <div className="menu-desc">Alumnos nuevos</div>
          </div>

          <div className="menu-card-item" onClick={() => navigate("matMenu")}>
            <div className="menu-icon icon-matricula">🎓</div>
            <div className="menu-label">Matriculación</div>
            <div className="menu-desc">Proceso de matrícula</div>
          </div>

          <div className="menu-card-item" onClick={() => {
            dispatch({ type: "REMOVE_TOKEN" });
            navigate("/");
          }}>
            <div className="menu-icon icon-salir">🚪</div>
            <div className="menu-label">Salir</div>
            <div className="menu-desc">Cerrar sesión</div>
          </div>
        </div>

        <div className="modern-copyright">
          {"© " + new Date().getFullYear() + " "}
          <a href="https://anai.edu.ec/" target="_blank" rel="noopener noreferrer">
            Academia Naval Almirante Illingworth
          </a>
          <br />
          <span style={{ fontSize: '0.75rem', color: '#999', marginTop: 4, display: 'inline-block' }}>Diseñado y Desarrollado por Departamento de Sistemas ANAI</span>
        </div>
      </div>
    </div>
  );
};
